<style lang="scss" scoped>
@import "core";

$my-transition-duration: .35s;

.bc-banner-rotate {
  @include bcb-reset;
  width: 100%;

  & > a {
    display: block;
    width: 100%;
    position: relative;

    & > img {
      width: 100%;
      max-width: none;
      vertical-align: bottom;
    }
  }

  &--exist {
    min-height: 1px;
  }
}

.my-link {
  transition: opacity .35s;

  &:hover {
    opacity: .9;
  }
}

.my-current-item {
  opacity: 1;
  position: relative;
  top: 0;
  left: 0;
  z-index: 0;

  &.is-now-transition {
    transition: opacity $my-transition-duration cubic-bezier(0.895, 0.03, 0.685, 0.22);
    opacity: 0;
  }
}

.my-next-item {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
}
.my-rotate-transition {

  &-enter {
    position: absolute;
    opacity: 0;

    &-active {
      transition: opacity $my-transition-duration cubic-bezier(0.25, 0.46, 0.45, 0.94);
    }

    &-to {
      opacity: 1;
    }
  }
}
</style>

<template>
  <div :class="classes" v-show="isExist">
    <a
      v-if="currentItem"
      class="my-link"
      :href="currentItem[`url_${mq}`]"
      :target="currentItem.blankWindow"
      @click="onItemClick(currentItem, $event)"
    >
      <img class="my-current-item" :class="currentItemClasses" :src="currentItem[`fileName_${mq}`]" alt="">
      <transition
        name="my-rotate-transition"
        @before-enter="$emit('next-item-before-enter')"
        @after-enter="$emit('next-item-after-enter')"
      >
        <img class="my-next-item" v-if="nextItem" :src="nextItem[`fileName_${mq}`]" alt="">
      </transition>
    </a>
  </div>
</template>

<script>
import bannerMixin from '../mixins/banner';



export default {
  name: 'bc-banner-rotate',

  mixins: [bannerMixin],

  props: {
  },

  data() {
    return {
      rotationTimerId: null,
      nextItem: null,
      nowTransition: false,
    }
  },

  computed: {
    classes() {
      return {
        [this.$options.name]: true,
        [`${this.$options.name}--exist`]: this.isExist,
      }
    },
    currentItemClasses() {
      return {
        'is-now-transition': this.nowTransition,
      };
    },
  },

  watch: {
    index() {
      if (this.index !== null) this.preloadNextIndex();
    },
  },

  methods: {
    prev(e) {
      this.slideIndex(-1);
    },
    next(e) {
      this.slideIndex(1);
    },
    preloadByIndex(index) {
      const nextItem = this.items.find(item => item.index === index);
      if (!nextItem) return;
      const image = new Image();
      image.src = nextItem[`fileName_${this.mq}`];
    },
    preloadNextIndex() {
      let nextIndex = this.index + 1;
      if (nextIndex >= this.count) {
        nextIndex = 0;
      }
      return this.preloadByIndex(nextIndex);
    },
    async slideIndex(ammount) {
      let nextIndex = this.index + ammount;
      if (nextIndex >= this.count) {
        nextIndex -= this.count;
      } else if (nextIndex < 0) {
        nextIndex += this.count;
      }

      this.nextItem = this.items[nextIndex];
      this.nowTransition = true;

      await new Promise((resolve, reject) => {
        this.$once('next-item-after-enter', resolve);
      });

      this.nextItem = null;
      this.nowTransition = false;
      this.index = nextIndex;
      this.preloadNextIndex();
    },
    startRotation() {
      if (!this.isExist || this.count === 1) return;
      if (this.isPause) return;

      this.stopRotation();
      this.rotationTimerId = setInterval(() => {
        this.next();
      }, this.rotateInterval);
    },
    stopRotation() {
      if (this.rotationTimerId !== null) {
        clearInterval(this.rotationTimerId);
        this.rotationTimerId = null;
      }
    },

    reset() {
      this.stopRotation();
    },
    start() {
      this.startRotation();
    },
    pauseAfter() {
      this.stopRotation();
    },
    resumeAfter() {
      this.startRotation();
    },
    beforeItemsUpdate() {
      this.reset();
    },
    afterItemsUpdate() {
      this.start();
    },
  },

  created() {
  },

  mounted() {
  },

  beforeDestroy() {
    this.reset();
  },
}

</script>


// WEBPACK FOOTER //
// Rotate.vue?26ab4491